module.exports = __webpack_public_path__ + "img/toucan-logo.add67432.svg";